export enum ePersonalizationKeys {
  TaskRoleFilters = 'Personalization.Key.TaskRoleFilters',
  TaskPersonFilter = 'Personalization.Key.TaskPersonFilter',
}
